import React, { useState, useEffect } from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showText?: boolean;
  customText?: string;
}

const loadingMessages = [
  "Preparando o sol para sua viagem... ☀️",
  "Carregando o mar com azul perfeito... 🌊",
  "Ajustando a brisa do vento para você... 🌬️",
  "Polindo a areia dourada da praia... 🏖️",
  "Organizando as dunas para sua aventura... 🏔️",
  "Preparando os coqueiros para sua sombra... 🌴",
  "Calibrando o pôr do sol perfeito... 🌅",
  "Aquecendo as águas cristalinas... 💎",
  "Sincronizando as ondas do mar... 🌊",
  "Preparando a magia de Jericoacoara... ✨"
];

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'md', 
  className = '',
  showText = true,
  customText
}) => {
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  useEffect(() => {
    if (!showText || customText) return;

    const interval = setInterval(() => {
      setCurrentMessageIndex((prev) => (prev + 1) % loadingMessages.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [showText, customText]);

  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8',
  };

  const textSizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg',
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <Loader2 className={`animate-spin ${sizeClasses[size]} text-blue-600 mb-3`} />
      {showText && (
        <p className={`text-gray-600 ${textSizeClasses[size]} text-center max-w-sm animate-pulse`}>
          {customText || loadingMessages[currentMessageIndex]}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
